module.exports = __webpack_public_path__ + "static/media/wanderer-bracelets-1.0f0e325a.jpg";